@use "src/theme";

.navigation {
  flex: 1;
  overflow-y: auto;
  scrollbar-color: var(--color-primary) transparent;
  scrollbar-width: thin;
  padding: 0.75rem 0.5rem;
}

.group + .group {
  margin-top: 1rem;
}

.label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.625rem 0.375rem;
  color: var(--color-muted-foreground);
}

.list {
  display: grid;
  gap: 0.125rem;
}

.item {
  position: relative;
  display: flex;
  width: 100%;
  min-height: 2.125rem;
  padding: 0.375rem 0.625rem;
  align-items: center;
  gap: 0.625rem;
  overflow: hidden;
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  color: var(--color-muted);
  font-size: 0.875rem;
  font-weight: 500;
  text-align: start;
  transition:
    color 140ms ease,
    background 140ms ease,
    border-color 140ms ease;

  &:hover {
    background: var(--color-card-hover);
    color: var(--color-foreground);
  }

  &:focus-visible {
    @include theme.focus-ring-inset;
  }

  &[data-selected="true"] {
    border-color: transparent;
    @include theme.nav-item-active;
  }
}

.icon {
  display: grid;
  width: 1.25rem;
  height: 1.25rem;
  flex: none;
  place-items: center;
  color: var(--color-muted-foreground);
}

.item[data-selected="true"] .icon {
  color: var(--color-primary);
}

.content {
  min-width: 0;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trailing {
  display: grid;
  flex: none;
  place-items: center;
  color: var(--color-muted-foreground);
}
